import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HeaderContainer, Logo, Nav, NavLinks, NavLink } from './styles';

const Header: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <HeaderContainer scrolled={scrolled}>
      <Link to="/">
        <Logo>
          <img src="/logo.svg" alt="PrezziePal" />
        </Logo>
      </Link>

      <Nav>
        <NavLinks>
          <NavLink to="/">Home</NavLink>
        </NavLinks>
      </Nav>
    </HeaderContainer>
  );
};

export default Header;
